import Box from '@mui/material/Box';

import { StatusChip } from '@/components/ui/StatusChip';

import { State } from '../State';

export function StatusChipExamples() {
  return (
    <State
      title="Four tones"
      note="The word carries the meaning; the icon and the colour only repeat it."
    >
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        <StatusChip label="Draft" tone="neutral" testId="gallery-status-chip-neutral" />
        <StatusChip
          label="Published"
          tone="success"
          testId="gallery-status-chip-success"
        />
        <StatusChip
          label="Unpublished changes"
          tone="warning"
          testId="gallery-status-chip-warning"
        />
        <StatusChip label="Unavailable" tone="error" testId="gallery-status-chip-error" />
      </Box>
    </State>
  );
}
